module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_3016.59c59f34.png";